import React from 'react';
import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LandingRoutes';
import MainRoutes from './AdminRoutes';

// ==============================|| ROUTING RENDER ||============================== //

function ThemeRoutes() {
    // LoginRoutes (public routes) must be first so landing page and login are accessible without auth
    return <div>{useRoutes([LoginRoutes, MainRoutes])}</div>;
}
export default ThemeRoutes;
